import * as React from "react";
import { Breadcrumbs } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
import { useFeatureToggles } from "@grandvisionhq/state";
import { createCategoryBreadcrumb } from "../../../utils/containers/Breadcrumbs/ProductBreadcrumbs/utils/create-category-breadcrumb.js";
import { createGraphProductBreadcrumb } from "../../../utils/containers/Breadcrumbs/ProductBreadcrumbs/utils/create-graph-product-breadcrumb.js";
import { createGraphSubCategoryBreadcrumb } from "../../../utils/containers/Breadcrumbs/ProductBreadcrumbs/utils/create-graph-subcategory-breadcrumb.js";
import { useBrPageContext } from "../../../../../../context/context/context.js";
import { useBloomreachProductRoutes } from "../../../../../../hooks/hooks/use-bloomreach-product-routes.js";
const CmsGraphProductBreadcrumbs = ({
  variant,
  productType,
  brandName
}) => {
  const { isPdpModelCodeDisabled } = useFeatureToggles();
  const page = useBrPageContext();
  const [, productRoutes] = useBloomreachProductRoutes();
  const categoryRoute = productRoutes[productType];
  if (!categoryRoute) {
    console.warn("Could not find a product category route to render PDP breadcrumbs");
    return null;
  }
  const categoryBreadcrumb = createCategoryBreadcrumb(categoryRoute, page);
  const subCategoryBreadcrumb = createGraphSubCategoryBreadcrumb(
    categoryRoute,
    brandName,
    page,
    variant
  );
  let variantDisplayName;
  if (isPdpModelCodeDisabled) {
    variantDisplayName = variant.displayName.replace("brandModelCode" in variant ? variant.brandModelCode ?? "" : "", "").replace(/ {2,}/g, " ").trim();
  } else {
    variantDisplayName = variant.displayName;
  }
  const productBreadcrumb = createGraphProductBreadcrumb(
    categoryBreadcrumb,
    variantDisplayName,
    productType === "Contact-lenses" ? "" : brandName
  );
  const breadcrumbs = [categoryBreadcrumb, subCategoryBreadcrumb, productBreadcrumb].filter(
    Boolean
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Breadcrumbs, { pages: breadcrumbs }));
};
export {
  CmsGraphProductBreadcrumbs,
  CmsGraphProductBreadcrumbs as default
};
//# sourceMappingURL=GraphProductBreadcrumbs.js.map
